export const validateOrganizationLength = new RegExp(/(?=.{5,})/)
export const validateOrganizationCharacters = new RegExp(/.{4,}$/)